export default __webpack_public_path__ + "static/media/features-split-image-03.7bd67155.png";